module.exports = __webpack_public_path__ + "img/receive-payment-banner.8871a211.png";